import Handlebars from '../../handlebars_helpers';

export default class TyreHandlebarsHelpers {
  static register() {
    Handlebars.registerHelper('selectedSpec', function (selections, position) {
      return selections.specification[position];
    });

    Handlebars.registerHelper('ifSelectedTyre', function (selections, position, tyre, options) {
      if (!selections.tyre(position)) return options.inverse(this);
      if (tyre.supplier_code === selections.tyre(position).supplier_code) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });

    Handlebars.registerHelper('isSymmetric', function (options) {
      if (this.symmetric()) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });

    Handlebars.registerHelper('tyreExtraInfo', (tyre) => {
      let seasonString, runFlatString, xlString;
      if (tyre.season) {
        seasonString = tyre.season.charAt(0).toUpperCase() + tyre.season.slice(1) + ' tyre';
      }
      if (tyre.rft) {
        runFlatString = 'Run flat';
      }
      if (tyre.xl) {
        xlString = 'Extra load';
      }
      return [seasonString, runFlatString, xlString].filter(Boolean).join('/');
    });
  }
}
